getUserAuthPlanList